import Vue from 'vue'
import { handleize } from '@/lib/util'
const ACCORDION_ACTIVE_CLASS = 'accordion--is-open'

Vue.component('accordions', {
  props: ['items', 'firstOpen'],
  data() {
    return {
      selectedIndex: this.firstOpen ? 0 : -1,
      accordionItems: [],
      accordionContents: [],
      contentWrapper: []
    }
  },
  watch: {
    'selectedIndex' (value) {
      if (value == null) {
        this.removeHeight()
      } else {
        this.removeHeight()
        this.setHeight(value)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.accordionItems = this.$refs.accordionItem
      this.accordionContents = this.$refs.content
      this.contentWrapper = this.$refs.contentWrapper
      this.setHeight(this.selectedIndex)
    })
  },
  methods: {
    handleize,
    toggle(id) {
      if (this.accordionItems[id].classList.contains(ACCORDION_ACTIVE_CLASS)) {
        this.selectedIndex = null
      } else {
        this.selectedIndex = id
      }
    },
    removeHeight() {
      this.accordionContents.forEach(content => content.style.height = 0)
    },
    setHeight(id) {
      if (this.accordionContents && this.accordionContents.length && this.contentWrapper && this.contentWrapper.length) {
        this.accordionContents[id].style.height = `${this.contentWrapper[id].offsetHeight + 25}px`
      }
    }
  }
})